<script setup lang="ts">
/** No "Publish" here: the index row carries no document to gate on. Archive / unarchive only. */
import type { AssignmentTemplateListRow } from '../../../model/assignments/interfaces'

import { faBoxArchive, faCopy, faPen, faRotateLeft, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useAssignmentTemplateActions } from '../../../model/assignments/assignment-template-actions.hook'

defineOptions({
  name: 'AssignmentTemplateActions',
})

const props = defineProps<{
  template: AssignmentTemplateListRow
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  refCanManage,
  refIsArchived,
  toggle,
  openEdit,
  openDuplicate,
  openDelete,
  archive,
  unarchive,
} = useAssignmentTemplateActions({
  template: computed(() => props.template),
})
</script>

<template>
  <div
    ref="containerRef"
    class="assignment-template-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for ${template.title}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="assignment-template-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="refCanManage"
          text="Duplicate"
          color="blue"
          :prepend-icon="faCopy"
          @click="openDuplicate"
        />
        <AppDropdownItem
          v-if="refCanManage && !refIsArchived"
          text="Archive"
          color="blue"
          :prepend-icon="faBoxArchive"
          @click="archive"
        />
        <AppDropdownItem
          v-if="refCanManage && refIsArchived"
          text="Unarchive as draft"
          color="blue"
          :prepend-icon="faRotateLeft"
          @click="unarchive"
        />
        <AppDropdownItem
          v-if="refCanManage"
          text="Delete"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AssignmentTemplateActions.scss" />
